module.exports = __webpack_public_path__ + "static/img/manual-40.7d1b7e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-40.png
// module id = Jw8z
// module chunks = 4